import React from 'react';
import NormalSelectInput from '../../ui/inputs/NormalSelectInput';
import NormalInput from '../../ui/inputs/NormalInput';
import '../../styles/components/prompt-builder/TimeframeSelector.scss';

interface TimeframeSelectorProps {
  timeframe: string;
  onTimeframeChange: (timeframe: string) => void;
  customDateRange: string;
  onCustomDateRangeChange: (range: string) => void;
}

const TIMEFRAMES = [
  { OptionValue: 'Today', OptionName: 'Today' },
  { OptionValue: 'Yesterday', OptionName: 'Yesterday' },
  { OptionValue: 'Last 7 days', OptionName: 'Last 7 days' },
  { OptionValue: 'Last 30 days', OptionName: 'Last 30 days' },
  { OptionValue: 'This month', OptionName: 'This month' },
  { OptionValue: 'Last month', OptionName: 'Last month' },
  { OptionValue: 'This quarter', OptionName: 'This quarter' },
  { OptionValue: 'Last quarter', OptionName: 'Last quarter' },
  { OptionValue: 'Year to date', OptionName: 'Year to date' },
  { OptionValue: 'Custom', OptionName: 'Custom date range' },
];

export const TimeframeSelector: React.FC<TimeframeSelectorProps> = ({
  timeframe,
  onTimeframeChange,
  customDateRange,
  onCustomDateRangeChange,
}) => {
  return (
    <div className='timeframe-selector'>
      <div className='timeframe-selector__select'>
        <NormalSelectInput
          defaultValue={timeframe}
          setSelect={onTimeframeChange}
          selectOptionArr={TIMEFRAMES}
          placeholder='Select timeframe'
          id='timeframe-select'
        />
      </div>

      {timeframe === 'Custom' && (
        <div className='timeframe-selector__custom'>
          <label
            htmlFor='custom-date-range'
            className='timeframe-selector__custom-label'
          >
            Enter custom date range
          </label>
          <div className='timeframe-selector__custom-input'>
            <NormalInput
              value={customDateRange}
              changeListeners={[(e) => onCustomDateRangeChange(e.target.value)]}
              innerPlaceholder='e.g., May 1 - May 15, 2023'
              id='custom-date-range'
            />
          </div>
          <div className='timeframe-selector__custom-help'>
            <span>
              Format: Start date - End date (e.g., May 1 - May 15, 2023)
            </span>
          </div>
        </div>
      )}
    </div>
  );
};
